export enum ActionInitState {
  open = 0,
  success = 1,
  failed = 2,
  wifiSkip = 3,
  noWifiService = 4
}
